import Item from 'es6/models/item';
import Memory from 'es6/models/memory';
import entity from 'es6/redux/modules/entity';

const items = entity('item', Item);
const itemsMemories = entity('itemMemory', Memory);

export const itemsReducer = items.reducer;
export const itemsActions = items.actions;
export const itemsMemoriesReducer = itemsMemories.reducer;
export const itemsMemoriesActions = itemsMemories.actions;
